module.exports = __webpack_public_path__ + "img/icon-nav-search-dark.141bc1c2.svg";